import classNames from 'classnames';
import classes from './SuccessMessage.module.css';

const SuccessMessage = ({ children, className=null }) => {

    return (
        <span className={classNames(classes.root, className)}>
            { children }
        </span>
    );
}

export default SuccessMessage;